import { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className="">

            {isVisible && (
                <div>
                    <button
                        onClick={scrollToTop}
                        className="right-4 z-50 p-3 rounded-full bg-[#383838] text-white shadow-lg transition-all duration-300 transform hover:scale-110"
                        aria-label="Scroll to top"
                        style={{ boxShadow: '0 4px 24px 0 rgba(56,56,56,0.18)' }}
                    >
                        <ChevronUp className="w-5 h-5 text-white" aria-label="Scroll to top icon" />
                    </button>
                </div>
            )}
            
        </div>
    );
};

export default ScrollToTop;
